module.exports = __webpack_public_path__ + "static/media/default-user-white.7e4af570.png";